<template>
  <div>
    <div class="animated fadeIn">
      <div class="row" style="width:100%;">
        <div class="col">
          <b-card :header="caption">
            <b-table
              :striped="true"
              :bordered="false"
              :small="false"
              :fixed="false"
              responsive="sm"
              :items="collection"
              :fields="fields">

              <template slot="HEAD_actions" slot-scope="data">
                <div class="text-center">{{ data.label }}</div>
              </template>

              <!-- A custom formatted column -->
              <template slot="user" slot-scope="data">
                {{ data.item.user.name }} <br>
                <small>{{ data.item.user.email }}</small>
              </template>

              <template slot="role" slot-scope="data">
                {{ data.item.user.roles.length ? data.item.user.roles[0].name : '' }}
              </template>

              <template slot="actions" slot-scope="data">
                <div class="d-flex justify-content-center">
                    <b-button variant="success" @click.stop="approve(data.item)">
                      <i class="fa fa-check"></i> Aprovar
                    </b-button>
                    <b-button variant="secondary" @click.stop="showDeclineModal(data.item)">
                      <i class="fa fa-times"></i> Recusar
                    </b-button>
                </div>
              </template>
            </b-table>
          </b-card>
        </div>
      </div>
    </div>

    <b-modal v-if="authorization" v-model="declineModal" title="Recusar Acesso " class="modal-primary" @ok="decline">
      Deseja realmente negar o acesso ao usuário {{ authorization.user.email }} ao sistema?<br>
      O usuário será removido e deverá se cadastrar novamente.
    </b-modal>
  </div>
</template>

<script>
  import { blAuthorizations as entity } from '@/_entities'
  import Authorizations from '@/services/api/bl-authorizations'

  export default {
    data () {
      return {
        entity: null,

        caption: 'Autorizações pendentes',

        authorization: null,

        declineModal: false,

        collection: [],

        fields: [
          { key: 'user', label: 'Usuário' },
          { key: 'role', label: 'Perfil' },
          { key: 'created_at', label: 'Data de criação' },
          { key: 'actions', label: 'Ações' }
        ]
      }
    },

    methods: {
      approve (authorization) {
        const self = this

        self.$Progress.start()
        return Authorizations.approve(authorization)
          .then((res) => {
            self.$Progress.finish()
            self.$toasted.success('Usuário autorizado com sucesso')
            self.refreshCollection()
          })
      },

      showDeclineModal (authorization) {
        this.authorization = authorization
        this.declineModal = true
      },

      decline () {
        const self = this

        self.declineModal = false
        self.$Progress.start()

        return Authorizations.decline(self.authorization)
          .then((res) => {
            self.$Progress.finish()
            self.$toasted.success('Autorização negada e o usuário foi removido.')
            self.refreshCollection()
            self.authorization = null
          })
      },

      refreshCollection () {
        const self = this

        self.$Progress.start()
        // Let's grab the most
        Authorizations.index({ params: {
          _search: { status: 0 },
          _with: 'user.roles',
          _onepage: true
        }}).then((res) => {
          self.$Progress.finish()
          self.collection = res.data.collection
        })
      }
    },

    created () {
      this.entity = entity

      // Let's grab the most
      this.refreshCollection()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/bl/AuthorizationIndex.vue